import { useEffect, useMemo, useState } from 'react';
import { GlobalState } from '@leverege/ui-redux';
import { DataSources } from '@leverege/ui-attributes';
import { Toolbar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import useRsrcImage from "../components/rsrcGallery/hooks/useRsrcImage.js";
import OverlayedImage from "../components/OverlayedImage.js";
import useOverlay from "../components/useOverlay.js";
import S from './OverlayImageViewer.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function OverlayImageViewer(props) {
  const {
    clientProps,
    path
  } = props;
  const {
    delegate,
    attribute: {
      source: {
        attribute
      }
    }
  } = clientProps;
  const [item, setItem] = useState();
  useEffect(() => {
    const load = async () => {
      let rsrc = delegate.resource(path).getRsrc(GlobalState.get());
      if (!rsrc) {
        rsrc = await GlobalState.dispatch(delegate.resource(path).get());
      }
      setItem({
        id: rsrc.id,
        type: 'rsrc',
        ref: `${delegate.getInterfaceUrl()}/rsrc`,
        data: rsrc
      });
    };
    load();
  }, [path]);
  const rsrcDelegate = useMemo(() => {
    if (item) {
      return DataSources.getDelegate(item)?.parent();
    }
    return null;
  }, [item]);
  const {
    ref,
    src
  } = useRsrcImage({
    item,
    delegate: rsrcDelegate
  });
  const hide = attribute.metadata?.overlays?.hidden;
  const {
    layers,
    loading
  } = useOverlay({
    item,
    src,
    path,
    exclude: Config.get('OverlayImageViewer', 'excludeLayers', hide)
  });
  const context = useMemo(() => {
    const layerKeys = Array.from(layers.reduce((prev, layer) => {
      if (layer.settingsKey) {
        prev.add(layer.settingsKey);
      }
      layer.data.forEach(datum => {
        if (datum.settingsKey) {
          prev.add(datum.settingsKey);
        }
      });
      return prev;
    }, new Set()));
    return {
      clientProps: {
        delegate: rsrcDelegate
      },
      layers: layerKeys
    };
  }, [rsrcDelegate, layers]);
  const matchContext = useMemo(() => {
    if (!rsrcDelegate) {
      return null;
    }
    return {
      client: 'OverlayDetailRenderer',
      objectType: rsrcDelegate?.relationship.objectType,
      path: rsrcDelegate?.relationship.path
    };
  }, [rsrcDelegate]);
  return /*#__PURE__*/_jsxs("div", {
    ref: ref,
    style: {
      width: '70vw',
      height: '70vh'
    },
    children: [loading && /*#__PURE__*/_jsx("div", {
      className: S.loader,
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-fw fa-spin fa-spinner fa-3x"
      })
    }), /*#__PURE__*/_jsx(OverlayedImage, {
      overlaysEnabled: true,
      layers: layers,
      src: src,
      context: context
    }), matchContext && /*#__PURE__*/_jsx(Toolbar, {
      layoutVariant: "flex:rowM",
      className: S.layerToolbar,
      matchContext: matchContext,
      context: context
    })]
  });
}
export default {
  type: 'overlay',
  component: OverlayImageViewer
};